import { GridToolsTypes } from '../constants/gridtoolsConstants';

const saved3dDicesEnable = JSON.parse(localStorage.getItem('config.enable3dDices') || null) ?? true;

const initialState = {
    tool: 'none',
    snap: 'auto',
    props: {},
    shouldSaveProps: true,
    gridId: '',
    activeGridId: '',
    propsGrid: {},
    selectedShapes: [],
    layers: [],
    selectedLayer: '',
    loadedGrid: null,
    syncRender: {},
    syncRenderOp: '',
    syncRenderItems: {},
    syncPropsGrid: {},
    signalBuffer: [],
    measureBuffer: null,
    measureClearBuffer: null,
    propagateTime: 0,
    movingBuffer: [],
    zoom: 7,
    centerPoint: [0,0],
    tokensOnGrid: {public: [], private: [],},
    enable3dDices: saved3dDicesEnable,
};

const changeIfInSameGrid = (state, render) => {
    if (state.activeGridId === state.gridId) {
        return {...render};
    }

    return state.syncRender;
}

const changeIfInSameGridOperation = (state, data) => {
    if (state.activeGridId === state.gridId) {
        return {...data};
    }

    return state.syncRenderItems;
}

export const gridtoolsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GridToolsTypes.SET_TOOL_MODE:
            return {
                ...state,
                tool: action.tool
            };

        case GridToolsTypes.SET_SNAP_MODE:
            return {
                ...state,
                snap: action.snap
            };

        case GridToolsTypes.SET_TOOL_PROPERTIES:
            return {
                ...state,
                props: {...action.toolprops},
                shouldSaveProps: action.save ?? true,
            };

        case GridToolsTypes.SET_SELECTED_GRID:
            return {
                ...state,
                gridId: action.gridId
            };

        case GridToolsTypes.SET_ACTIVE_GRID:
            return {
                ...state,
                activeGridId: action.gridId
            };

        case GridToolsTypes.SET_PROPS_GRID:
            return {
                ...state,
                propsGrid: {...action.props}
            };

        case GridToolsTypes.SET_LAYERS:
            return {
                ...state,
                layers: [...action.layers]
            };

        case GridToolsTypes.SET_SELECTED_LAYER:
            return {
                ...state,
                selectedLayer: action.selectedLayer
            };

        case GridToolsTypes.SET_SHAPE_SELECTED:
            return {
                ...state,
                selectedShapes: [...action.selected]
            };

        case GridToolsTypes.SET_LOADED_GRID:
            return {
                ...state,
                loadedGrid: action.grid
            };

        case GridToolsTypes.SET_SYNC_RENDER_GRID:
            return {
                ...state,
                syncRender: changeIfInSameGrid(state, action.render)
            };

        case GridToolsTypes.SET_SYNC_RENDER_OPERATION_GRID:
            return {
                ...state,
                syncRenderOp: action.op,
                syncRenderItems: changeIfInSameGridOperation(state, action.data)
            };

        case GridToolsTypes.SET_SYNC_PROPS_GRID:
            return {
                ...state,
                syncPropsGrid: action.props
            };

        case GridToolsTypes.SIGNAL_GRID:
            return {
                ...state,
                signalBuffer: [...state.signalBuffer, action.signal]
            };
            
        case GridToolsTypes.MEASURE_GRID:
            return {
                ...state,
                measureBuffer: {...action.measure}
            };

        case GridToolsTypes.MOVING_GRID:
            return {
                ...state,
                movingBuffer: {...action.moving}
            };
            
        case GridToolsTypes.SIGNAL_CLEAR_GRID:
            return {
                ...state,
                signalBuffer: []
            };

        case GridToolsTypes.MEASURE_CLEAR_GRID:
            return {
                ...state,
                measureClearBuffer: action.measureId
            };
            
        case GridToolsTypes.PROPAGATE_CHANGES_GRID:
            return {
                ...state,
                propagateTime: (new Date()).getTime()
            };

        case GridToolsTypes.ZOOM_CHANGE:
            return {
                ...state,
                zoom: action.zoom
            };

        case GridToolsTypes.CENTER_CHANGE:
            return {
                ...state,
                centerPoint: [...action.center]
            };

        case GridToolsTypes.DICE_3D_STATE_TOGGLE:
            localStorage.setItem('config.enable3dDices', JSON.stringify(!state.enable3dDices));
            return {
                ...state,
                enable3dDices: !state.enable3dDices
            };

        case GridToolsTypes.SET_TOKEN_PRESENCE:
            return {
                ...state,
                tokensOnGrid: {
                    public: [...action.tokens.public],
                    private: [...action.tokens.private],
                },
            };

        case GridToolsTypes.RESET:
            return {
                ...state,
                ...initialState
            };
        
        default:
            return state;
    }
};